import { DateTime } from 'luxon';
import { Formatter } from 'dg-web-shared/lib/Date.ts';

export const ISO_MONDAY = 1;
export const ISO_TUESDAY = 2;
export const ISO_WEDNESDAY = 3;
export const ISO_THURSDAY = 4;
export const ISO_FRIDAY = 5;
export const ISO_SATURDAY = 6;
export const ISO_SUNDAY = 7;

export function addDays(date: DateTime, addDays: number): string {
    return Formatter.isoYearMonthDay(date.plus({ days: addDays }));
}

export function nextWeekdayAfter(
    refDay: DateTime,
    targetIsoWeekday: number,
): DateTime {
    const daysToAdd = (targetIsoWeekday - refDay.weekday + 7) % 7; // ensure positive result
    return refDay.plus({ days: daysToAdd });
}

export function getEasterSunday(year: number): DateTime {
    if (year <= 0 || year >= 10000) {
        throw new Error('Invalid year ' + year);
    }

    // using the "Anonymous Gregorian Algorithm", see http://en.wikipedia.org/wiki/Computus#Algorithms
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const L = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * L) / 451);
    const n = h + L - 7 * m + 114;
    const month = Math.floor(n / 31);
    const day = (n % 31) + 1;

    return DateTime.local(year, month, day);
}

export function getHilariFriday(year: number): DateTime {
    // 13.01 if friday
    // 12.01 if 13.01 is saturday
    // otherwise subsequent weekend

    const refDay = DateTime.local(year, 1, 13);
    if (refDay.weekday === ISO_FRIDAY) {
        return refDay;
    } else if (refDay.weekday === ISO_SATURDAY) {
        return refDay.minus({ days: 1 });
    } else {
        const nextFriday = nextWeekdayAfter(refDay, ISO_FRIDAY);
        return nextFriday;
    }
}

export function getMaienzug(year: number): DateTime {
    // first Friday in July
    const refDay = DateTime.local(year, 7, 1);
    const firstFriday = nextWeekdayAfter(refDay, ISO_FRIDAY);
    return firstFriday;
}

export function getKnabenschiessenMonday(year: number): DateTime {
    // Monday after second weekend in September or one week before Eidg. Bettag

    const refDay = DateTime.local(year, 9, 1);
    const firstSaturday = nextWeekdayAfter(refDay, ISO_SATURDAY);
    let knabenschiessenSunday = firstSaturday.plus({ weeks: 1, days: 1 });
    if (knabenschiessenSunday.hasSame(getEidgBettag(year), 'day')) {
        knabenschiessenSunday = knabenschiessenSunday.minus({ weeks: 1 });
    }
    return knabenschiessenSunday.plus({ days: 1 });
}

export function getEidgBettag(year: number): DateTime {
    // third Sunday in September
    const refDay = DateTime.local(year, 9, 1);
    const firstSunday = nextWeekdayAfter(refDay, ISO_SUNDAY);
    return firstSunday.plus({ weeks: 2 });
}

export function getGenevaBettag(year: number): DateTime {
    // Thursday following the first Sunday of September
    const refDay = DateTime.local(year, 9, 1);
    const firstSunday = nextWeekdayAfter(refDay, ISO_SUNDAY);
    return firstSunday.plus({ days: 4 });
}
